import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync, faEye } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './ProductosData.css'
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import baseURL from '../../url';
import NewProduct from '../NewProduct/NewProduct';
import BulkProductImport from '../BulkProductImport/BulkProductImport';
import { getProductMoneda } from '../../moneda';
import { Link as Anchor } from "react-router-dom";
import { getItemOptions, getTotalStockFromItemStocks, hasConfiguredVariants as hasConfiguredVariantsInProduct, isCustomPrice, isStockNotRequired } from '../../productStock';
import { guardarSiteConfig } from '../../siteConfig';
import ProductDescriptionEditor from '../../ProductDescriptionEditor/ProductDescriptionEditor';
import ProductMedia, { getFirstProductMedia, isVideoMedia } from '../../ProductMedia/ProductMedia';

const STOCK_NO_NECESARIO_VALUE = 999999;
const PRODUCT_MEDIA_ACCEPT = 'image/*,video/mp4,video/webm,video/ogg,video/quicktime';
const PREFERRED_SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL'];

function getVariantStockPreview(producto) {
    const itemOptions = getItemOptions(producto);
    if (itemOptions.length === 0) {
        return [];
    }

    const normalizedMap = new Map(
        itemOptions.map((option) => [option.label.trim().toUpperCase(), option])
    );

    const preferred = PREFERRED_SIZE_ORDER
        .map((size) => normalizedMap.get(size))
        .filter(Boolean);

    if (preferred.length > 0) {
        return preferred;
    }

    return itemOptions.slice(0, 5);
}

function getVariantStockToneClass(stock) {
    const stockNumber = Number(stock || 0);

    if (stockNumber <= 0) {
        return 'is-empty';
    }

    if (stockNumber <= 2) {
        return 'is-danger';
    }

    if (stockNumber <= 5) {
        return 'is-warning';
    }

    return 'is-good';
}
export default function ProductosData() {
    const [productos, setProductos] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevoTitulo, setNuevoTitulo] = useState('');
    const [nuevoSku, setNuevoSku] = useState('');
    const [nuevaMarca, setNuevaMarca] = useState('');
    const [nuevaDescripcion, setNuevaDescripcion] = useState('');
    const [nuevoPrecio, setNuevoPrecio] = useState('');
    const [precioPersonalizable, setPrecioPersonalizable] = useState(false);
    const [nuevoPrecioAnterior, setNuevoPrecioAnterior] = useState(0);
    const [nuevaCategoria, setNuevaCategoria] = useState('');
    const [producto, setProducto] = useState({});
    const [modalImagenVisible, setModalImagenVisible] = useState(false);
    const [imagenSeleccionada, setImagenSeleccionada] = useState('');
    const [filtroId, setFiltroId] = useState('');
    const [filtroTitulo, setFiltroTitulo] = useState('');
    const [filtroCategoria, setFiltroCategoria] = useState('');
    const [filtroMarca, setFiltroMarca] = useState('');
    const [filtroMasVendido, setFiltroMasVendido] = useState('');
    const [outOfStockLabel, setOutOfStockLabel] = useState('agotado');
    const [savingOutOfStockLabel, setSavingOutOfStockLabel] = useState(false);
    const [ordenInvertido, setOrdenInvertido] = useState(false);
    const [imagenPreview, setImagenPreview] = useState(null);
    const [imagenPreview2, setImagenPreview2] = useState(null);
    const [imagenPreview3, setImagenPreview3] = useState(null);
    const [imagenPreview4, setImagenPreview4] = useState(null);
    const [imagenPreview5, setImagenPreview5] = useState(null);
    const [imagenPreview6, setImagenPreview6] = useState(null);
    const [imagenPreview7, setImagenPreview7] = useState(null);
    const [imagenPreview8, setImagenPreview8] = useState(null);
    const [imagenPreview9, setImagenPreview9] = useState(null);
    const [imagenPreview10, setImagenPreview10] = useState(null);
    const [nuevaImagen, setNuevaImagen] = useState(null);
    const [nuevaImagen2, setNuevaImagen2] = useState(null);
    const [nuevaImagen3, setNuevaImagen3] = useState(null);
    const [nuevaImagen4, setNuevaImagen4] = useState(null);
    const [nuevaImagen5, setNuevaImagen5] = useState(null);
    const [nuevaImagen6, setNuevaImagen6] = useState(null);
    const [nuevaImagen7, setNuevaImagen7] = useState(null);
    const [nuevaImagen8, setNuevaImagen8] = useState(null);
    const [nuevaImagen9, setNuevaImagen9] = useState(null);
    const [nuevaImagen10, setNuevaImagen10] = useState(null);
    const [removedImages, setRemovedImages] = useState({
        imagen1: false,
        imagen2: false,
        imagen3: false,
        imagen4: false,
        imagen5: false,
        imagen6: false,
        imagen7: false,
        imagen8: false,
        imagen9: false,
        imagen10: false,
    });
    const [selectedSection, setSelectedSection] = useState('texto');
    const [nuevoMasVendido, setNuevoMasVendido] = useState('');
    const [categorias, setCategoras] = useState([]);
    const [item1, setItem1] = useState('');
    const [item2, setItem2] = useState('');
    const [item3, setItem3] = useState('');
    const [item4, setItem4] = useState('');
    const [item5, setItem5] = useState('');
    const [item6, setItem6] = useState('');
    const [item7, setItem7] = useState('');
    const [item8, setItem8] = useState('');
    const [item9, setItem9] = useState('');
    const [item10, setItem10] = useState('');
    const [itemStocks, setItemStocks] = useState({
        itemStock1: '',
        itemStock2: '',
        itemStock3: '',
        itemStock4: '',
        itemStock5: '',
        itemStock6: '',
        itemStock7: '',
        itemStock8: '',
        itemStock9: '',
        itemStock10: '',
    });
    const [stockGeneral, setStockGeneral] = useState('');
    const [stockNoNecesario, setStockNoNecesario] = useState(false);
    const cerrarModalImagen = () => {
        setModalImagenVisible(false);
    };
    const abrirModalImagenSeleccionada = (imagen) => {
        setImagenSeleccionada(imagen);
        setModalImagenVisible(true);
    };


    useEffect(() => {
        cargarProductos();
        cargarConfiguracion();

    }, []);

    useEffect(() => {
        // Actualiza el valor del select cuando cambia el estado nuevoEstado
        setNuevoTitulo(producto.titulo);
        setNuevoSku(producto.sku || '');
        setNuevaMarca(producto.marca || '');
        setNuevaDescripcion(producto.descripcion);
        setNuevoPrecio(producto.precio);
        setPrecioPersonalizable(isCustomPrice(producto));
        setNuevoMasVendido(producto.masVendido)
        setNuevaCategoria(producto.idCategoria)
        setItem1(producto.item1);
        setItem2(producto.item2);
        setItem3(producto.item3);
        setItem4(producto.item4);
        setItem5(producto.item5);
        setItem6(producto.item6);
        setItem7(producto.item7);
        setItem8(producto.item8);
        setItem9(producto.item9);
        setItem10(producto.item10);
        setNuevoPrecioAnterior(producto.precioAnterior)
        setItemStocks({
            itemStock1: producto.itemStock1 ?? '',
            itemStock2: producto.itemStock2 ?? '',
            itemStock3: producto.itemStock3 ?? '',
            itemStock4: producto.itemStock4 ?? '',
            itemStock5: producto.itemStock5 ?? '',
            itemStock6: producto.itemStock6 ?? '',
            itemStock7: producto.itemStock7 ?? '',
            itemStock8: producto.itemStock8 ?? '',
            itemStock9: producto.itemStock9 ?? '',
            itemStock10: producto.itemStock10 ?? '',
        });
        setStockGeneral(producto.stock ?? '');
        setStockNoNecesario(isStockNotRequired(producto));
        setImagenPreview(null);
        setImagenPreview2(null);
        setImagenPreview3(null);
        setImagenPreview4(null);
        setImagenPreview5(null);
        setImagenPreview6(null);
        setImagenPreview7(null);
        setImagenPreview8(null);
        setImagenPreview9(null);
        setImagenPreview10(null);
        setNuevaImagen(null);
        setNuevaImagen2(null);
        setNuevaImagen3(null);
        setNuevaImagen4(null);
        setNuevaImagen5(null);
        setNuevaImagen6(null);
        setNuevaImagen7(null);
        setNuevaImagen8(null);
        setNuevaImagen9(null);
        setNuevaImagen10(null);
        setRemovedImages({
            imagen1: false,
            imagen2: false,
            imagen3: false,
            imagen4: false,
            imagen5: false,
            imagen6: false,
            imagen7: false,
            imagen8: false,
            imagen9: false,
            imagen10: false,
        });
    }, [producto]);

    const itemFields = [
        { legend: 'Item 1', value: item1, setValue: setItem1, stockKey: 'itemStock1' },
        { legend: 'Item 2', value: item2, setValue: setItem2, stockKey: 'itemStock2' },
        { legend: 'Item 3', value: item3, setValue: setItem3, stockKey: 'itemStock3' },
        { legend: 'Item 4', value: item4, setValue: setItem4, stockKey: 'itemStock4' },
        { legend: 'Item 5', value: item5, setValue: setItem5, stockKey: 'itemStock5' },
        { legend: 'Item 6', value: item6, setValue: setItem6, stockKey: 'itemStock6' },
        { legend: 'Item 7', value: item7, setValue: setItem7, stockKey: 'itemStock7' },
        { legend: 'Item 8', value: item8, setValue: setItem8, stockKey: 'itemStock8' },
        { legend: 'Item 9', value: item9, setValue: setItem9, stockKey: 'itemStock9' },
        { legend: 'Item 10', value: item10, setValue: setItem10, stockKey: 'itemStock10' },
    ];
    const totalStock = getTotalStockFromItemStocks(itemStocks);
    const hasConfiguredVariants = hasConfiguredVariantsInProduct({
        item1,
        item2,
        item3,
        item4,
        item5,
        item6,
        item7,
        item8,
        item9,
        item10,
        ...itemStocks,
    });
    const productMediaSlots = [
        { key: 'imagen1', label: 'Imagen/Video 1', preview: imagenPreview, setPreview: setImagenPreview, file: nuevaImagen, setFile: setNuevaImagen },
        { key: 'imagen2', label: 'Imagen/Video 2', preview: imagenPreview2, setPreview: setImagenPreview2, file: nuevaImagen2, setFile: setNuevaImagen2 },
        { key: 'imagen3', label: 'Imagen/Video 3', preview: imagenPreview3, setPreview: setImagenPreview3, file: nuevaImagen3, setFile: setNuevaImagen3 },
        { key: 'imagen4', label: 'Imagen/Video 4', preview: imagenPreview4, setPreview: setImagenPreview4, file: nuevaImagen4, setFile: setNuevaImagen4 },
        { key: 'imagen5', label: 'Imagen/Video 5', preview: imagenPreview5, setPreview: setImagenPreview5, file: nuevaImagen5, setFile: setNuevaImagen5 },
        { key: 'imagen6', label: 'Imagen/Video 6', preview: imagenPreview6, setPreview: setImagenPreview6, file: nuevaImagen6, setFile: setNuevaImagen6 },
        { key: 'imagen7', label: 'Imagen/Video 7', preview: imagenPreview7, setPreview: setImagenPreview7, file: nuevaImagen7, setFile: setNuevaImagen7 },
        { key: 'imagen8', label: 'Imagen/Video 8', preview: imagenPreview8, setPreview: setImagenPreview8, file: nuevaImagen8, setFile: setNuevaImagen8 },
        { key: 'imagen9', label: 'Imagen/Video 9', preview: imagenPreview9, setPreview: setImagenPreview9, file: nuevaImagen9, setFile: setNuevaImagen9 },
        { key: 'imagen10', label: 'Imagen/Video 10', preview: imagenPreview10, setPreview: setImagenPreview10, file: nuevaImagen10, setFile: setNuevaImagen10 },
    ];

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
                console.log(data.productos)
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const cargarConfiguracion = () => {
        fetch(`${baseURL}/configGet.php?ts=${Date.now()}`, {
            method: 'GET',
            cache: 'no-store',
        })
            .then(response => response.json())
            .then(data => {
                if (data.config) {
                    guardarSiteConfig(data.config);
                    setOutOfStockLabel(data.config.outOfStockLabel === 'vendido' ? 'vendido' : 'agotado');
                }
            })
            .catch(error => console.error('Error al cargar configuración de productos:', error));
    };

    const handleOutOfStockLabelChange = (event) => {
        const nextLabel = event.target.value === 'vendido' ? 'vendido' : 'agotado';
        const formData = new FormData();
        formData.append('outOfStockLabel', nextLabel);

        setOutOfStockLabel(nextLabel);
        setSavingOutOfStockLabel(true);

        fetch(`${baseURL}/configPost.php`, {
            method: 'POST',
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    toast.error(data.error);
                    cargarConfiguracion();
                    return;
                }

                toast.success('Texto de productos agotados actualizado');
                cargarConfiguracion();
            })
            .catch(error => {
                toast.error(error.message);
                cargarConfiguracion();
            })
            .finally(() => setSavingOutOfStockLabel(false));
    };

    const eliminarProducto = (idProducto) => {
        // Reemplaza el window.confirm con SweetAlert2
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#780576',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/productDelete.php?idProducto=${idProducto}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        cargarProductos();
                    })
                    .catch(error => {
                        console.error('Error al eliminar la Producto:', error);
                        toast.error(error);
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setProducto(item);
        setNuevoTitulo(item.titulo);
        setNuevaMarca(item.marca || '');
        setNuevaDescripcion(item.descripcion);
        setNuevoPrecio(item.precio);
        setPrecioPersonalizable(isCustomPrice(item));
        setStockNoNecesario(isStockNotRequired(item));
        setNuevaCategoria(producto.idCategoria);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const productosFiltrados = productos.filter(item => {
        const idMatch = item.idProducto.toString().includes(filtroId);
        const tituloMatch = !filtroTitulo || item.titulo.includes(filtroTitulo);
        const categoriaMatch = item.idCategoria.toString().includes(filtroCategoria);
        const marcaMatch = !filtroMarca || String(item.marca || '') === filtroMarca;
        const masVendidoMatch = !filtroMasVendido || item.masVendido.includes(filtroMasVendido);
        return idMatch && tituloMatch && categoriaMatch && marcaMatch && masVendidoMatch;
    });
    const shouldShowSkuColumn = productos.some((item) => String(item?.sku || '').trim() !== '');
    const shouldShowBrandColumn = productos.some((item) => String(item?.marca || '').trim() !== '');
    const marcasDisponibles = [...new Set(
        productos
            .map((item) => String(item?.marca || '').trim())
            .filter(Boolean)
    )].sort((left, right) => left.localeCompare(right, 'es', { sensitivity: 'base' }));

    const descargarExcel = () => {
        const data = productosFiltrados.map(item => ({
            IdProducto: item.idProducto,
            Marca: item.marca || '',
            Titulo: item.titulo,
            SKU: item.sku || '',
            Descripcion: item.descripcion,
            Precio: item.precio,
            Fecha: item.createdAt,
            MasVendido: item.masVendido,
            Imagen1: item.imagen1,
            Imagen2: item.imagen2,
            Imagen3: item.imagen3,
            Imagen4: item.imagen4,

        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Productos');
        XLSX.writeFile(wb, 'productos.xlsx');
    };

    const descargarPDF = () => {
        const pdf = new jsPDF();
        pdf.text('Lista de Productos', 10, 10);

        const columns = [
            { title: 'IdProducto', dataKey: 'idProducto' },
            { title: 'Marca', dataKey: 'marca' },
            { title: 'Titulo', dataKey: 'titulo' },
            { title: 'SKU', dataKey: 'sku' },
            { title: 'Descripcion', dataKey: 'descripcion' },
            { title: 'Precio', dataKey: 'precio' },
            { title: 'MasVendido', dataKey: 'masVendido' },
            { title: 'Fecha', dataKey: 'createdAt' },
        ];

        const data = productosFiltrados.map(item => ({
            IdProducto: item.idProducto,
            Marca: item.marca || '',
            Titulo: item.titulo,
            SKU: item.sku || '',
            Descripcion: item.descripcion,
            Precio: item.precio,
            MasVendido: item.masVendido,
            Fecha: item.createdAt,

        }));

        pdf.autoTable({
            head: [columns.map(col => col.title)],
            body: data.map(item => Object.values(item)),
        });

        pdf.save('productos.pdf');
    };

    const recargarProductos = () => {
        cargarProductos();
    };
    const invertirOrden = () => {
        setProductos([...productos].reverse());
        setOrdenInvertido(!ordenInvertido);
    };


    const handleUpdateText = (idProducto) => {
        const payload = {

            nuevoTitulo: nuevoTitulo !== '' ? nuevoTitulo : producto.titulo,
            nuevoSku,
            nuevaMarca,
            nuevaDescripcion: nuevaDescripcion !== undefined ? nuevaDescripcion : producto.descripcion,
            nuevoPrecio: precioPersonalizable ? 0 : (nuevoPrecio !== '' ? nuevoPrecio : producto.precio),
            precioPersonalizable: precioPersonalizable ? 1 : 0,
            nuevaCategoria: nuevaCategoria !== '' ? nuevaCategoria : producto.idCategoria,
            masVendido: nuevoMasVendido !== '' ? nuevoMasVendido : producto.masVendido,
            item1: item1 !== undefined ? item1 : producto.item1,
            item2: item2 !== undefined ? item2 : producto.item2,
            item3: item3 !== undefined ? item3 : producto.item3,
            item4: item4 !== undefined ? item4 : producto.item4,
            item5: item5 !== undefined ? item5 : producto.item5,
            item6: item6 !== undefined ? item6 : producto.item6,
            item7: item7 !== undefined ? item7 : producto.item7,
            item8: item8 !== undefined ? item8 : producto.item8,
            item9: item9 !== undefined ? item9 : producto.item9,
            item10: item10 !== undefined ? item10 : producto.item10,
            itemStock1: itemStocks.itemStock1,
            itemStock2: itemStocks.itemStock2,
            itemStock3: itemStocks.itemStock3,
            itemStock4: itemStocks.itemStock4,
            itemStock5: itemStocks.itemStock5,
            itemStock6: itemStocks.itemStock6,
            itemStock7: itemStocks.itemStock7,
            itemStock8: itemStocks.itemStock8,
            itemStock9: itemStocks.itemStock9,
            itemStock10: itemStocks.itemStock10,
            precioAnterior: nuevoPrecioAnterior !== 0 ? nuevoPrecioAnterior : producto.precioAnterior,
            stock: stockNoNecesario ? STOCK_NO_NECESARIO_VALUE : (hasConfiguredVariants ? totalStock : (stockGeneral !== '' ? stockGeneral : (producto.stock ?? 0))),
            stockNoNecesario: stockNoNecesario ? 1 : 0,
        };

        fetch(`${baseURL}/productoTextPut.php?idProducto=${idProducto}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {

                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                } else {

                    Swal.fire(
                        'Editado!',
                        data.mensaje,
                        'success'
                    );
                    cargarProductos();
                    cerrarModal()
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };

    const handleFileChange = (event, setFile, setPreview, imageKey) => {
        const file = event.target.files[0];

        if (file) {
            const previewURL = URL.createObjectURL(file);
            setFile(file);
            setPreview(previewURL);
            if (imageKey) {
                setRemovedImages((prev) => ({
                    ...prev,
                    [imageKey]: false,
                }));
            }
        }
    };
    const handleEditarImagenBanner = (idProducto) => {
        const formData = new FormData();
        formData.append('idProducto', idProducto);
        formData.append('updateAction', 'update'); // Campo adicional para indicar que es una actualización

        const nextVideoCount = productMediaSlots.reduce((total, slot) => {
            if (slot.file) {
                return total + (slot.file.type.startsWith('video/') ? 1 : 0);
            }

            if (removedImages[slot.key]) {
                return total;
            }

            return total + (isVideoMedia(producto[slot.key]) ? 1 : 0);
        }, 0);

        if (nextVideoCount > 2) {
            toast.error('Solo puedes tener hasta 2 videos por producto.');
            return;
        }

        productMediaSlots.forEach((slot) => {
            if (slot.file) {
                formData.append(slot.key, slot.file);
            }
        });

        Object.entries(removedImages).forEach(([imageKey, shouldRemove]) => {
            if (shouldRemove) {
                formData.append(`remove_${imageKey}`, '1');
            }
        });

        fetch(`${baseURL}/productoImagePut.php`, {
            method: 'POST',  // Cambiado a POST
            body: formData
        })
            .then(response => {
                // Manejar el caso cuando la respuesta no es un JSON válido o está vacía
                if (!response.ok) {
                    throw new Error('La solicitud no fue exitosa');

                }

                return response.json();
            })
            .then(data => {
                if (data.error) {

                    toast.error(data.error);
                    console.log(formData)
                } else {

                    toast.success(data.mensaje);
                    window.location.reload();
                }
            })
            .catch(error => {
                console.log(error)
                toast.error(error.message);
                console.log(formData)
                console.log(idProducto)
            });
    };

    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };

    const markImageForRemoval = (imageKey) => {
        setRemovedImages((prev) => ({
            ...prev,
            [imageKey]: true,
        }));
    };

    useEffect(() => {
        cargarCategoria();
    }, []);


    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategoras(data.categorias || []);
                console.log(data.categorias)
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const handleItemStockChange = (key, value) => {
        setItemStocks((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    return (
        <div>
            <BulkProductImport onImported={cargarProductos} />
            <div className='productSettingsPanel'>
                <div>
                    <h3>Texto para productos sin stock</h3>
                    <p>Elige la etiqueta que verá el cliente en los bloques de producto.</p>
                </div>
                <select value={outOfStockLabel} onChange={handleOutOfStockLabelChange} disabled={savingOutOfStockLabel}>
                    <option value="agotado">Agotado</option>
                    <option value="vendido">Vendido</option>
                </select>
            </div>
            <div className='deFlexContent'>

                <div className='deFlex2'>
                    <NewProduct />
                    <button className='excel' onClick={descargarExcel}><FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                    <button className='pdf' onClick={descargarPDF}><FontAwesomeIcon icon={faArrowDown} /> PDF</button>
                </div>
                <div className='filtrosContain'>
                    <div className='inputsColumn'>
                        <input type="number" value={filtroId} onChange={(e) => setFiltroId(e.target.value)} placeholder='Id Producto' />
                    </div>

                    <div className='inputsColumn'>
                        <input type="text" value={filtroTitulo} onChange={(e) => setFiltroTitulo(e.target.value)} placeholder='Titulo' />
                    </div>

                    <div className='inputsColumn'>
                        <select value={filtroMarca} onChange={(e) => setFiltroMarca(e.target.value)}>
                            <option value="">Marca</option>
                            {marcasDisponibles.map((marca) => (
                                <option key={marca} value={marca}>{marca}</option>
                            ))}
                        </select>
                    </div>

                    <div className='inputsColumn'>
                        <select value={filtroCategoria} onChange={(e) => setFiltroCategoria(e.target.value)}>
                            <option value="">Categorias</option>
                            {
                                categorias.map(item => (
                                    <option value={item?.idCategoria}>{item?.categoria}</option>
                                ))
                            }
                        </select>
                    </div>

                    <div className='inputsColumn'>
                        <select value={filtroMasVendido} onChange={(e) => setFiltroMasVendido(e.target.value)}>
                            <option value="">Más vendidos</option>
                            <option value="si">Si</option>
                            <option value="no">No</option>

                        </select>
                    </div>

                    <button className='reload' onClick={recargarProductos}><FontAwesomeIcon icon={faSync} /></button>
                    <button className='reverse' onClick={invertirOrden}>
                        {ordenInvertido ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />}
                    </button>

                </div>

            </div>


            {modalImagenVisible && (
                <div className="modalImg">
                    <div className="modal-contentImg">


                        <span className="close2" onClick={cerrarModalImagen}>
                            &times;
                        </span>

                        <ProductMedia src={imagenSeleccionada} alt="Archivo seleccionado" className="productMediaModal" controls />
                    </div>
                </div>
            )}

            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>

                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Editar Texto
                                </button>
                                <button
                                    className={selectedSection === 'imagenes' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('imagenes')}
                                >
                                    Editar Imagenes
                                </button>
                            </div>
                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Titulo</legend>
                                    <input
                                        type="text"
                                        value={nuevoTitulo !== '' ? nuevoTitulo : producto.titulo}
                                        onChange={(e) => setNuevoTitulo(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>SKU</legend>
                                    <input
                                        type="text"
                                        value={nuevoSku}
                                        onChange={(e) => setNuevoSku(e.target.value)}
                                        placeholder="Ej: SKU-001"
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Marca</legend>
                                    <input
                                        type="text"
                                        value={nuevaMarca}
                                        onChange={(e) => setNuevaMarca(e.target.value)}
                                        placeholder="Ej: Nike"
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Precio</legend>
                                    <input
                                        type="number"
                                        value={precioPersonalizable ? '' : (nuevoPrecio !== '' ? nuevoPrecio : producto.precio)}
                                        onChange={(e) => setNuevoPrecio(e.target.value)}
                                        disabled={precioPersonalizable}
                                    />
                                </fieldset>
                                <fieldset className='checkboxField'>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={precioPersonalizable}
                                            onChange={(e) => setPrecioPersonalizable(e.target.checked)}
                                        />
                                        Personalizable
                                    </label>
                                </fieldset>
                                <fieldset id='descripcion'>
                                    <legend>Descripcion</legend>
                                    <ProductDescriptionEditor
                                        id="editarDescripcion"
                                        name="editarDescripcion"
                                        value={nuevaDescripcion}
                                        onChange={setNuevaDescripcion}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Categoria</legend>
                                    <select
                                        value={nuevaCategoria !== '' ? nuevaCategoria : producto.categoria}
                                        onChange={(e) => setNuevaCategoria(e.target.value)}
                                    >

                                        {
                                            categorias
                                                .filter(categoriaFiltrada => categoriaFiltrada.idCategoria === producto.idCategoria)
                                                .map(categoriaFiltrada => (

                                                    <option value={producto.categoria}> {categoriaFiltrada.categoria}</option>
                                                ))
                                        }

                                        {
                                            categorias.map(item => (
                                                <option value={item?.idCategoria}>{item?.categoria}</option>
                                            ))
                                        }
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Más vendido</legend>
                                    <select
                                        value={nuevoMasVendido !== '' ? nuevoMasVendido : producto.masVendido}
                                        onChange={(e) => setNuevoMasVendido(e.target.value)}
                                    >
                                        <option value={producto.masVendido}>{producto.masVendido}</option>
                                        <option value="si">Si</option>
                                        <option value="no">No</option>
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Stock total</legend>

                                    <input
                                        type="number"
                                        min="0"
                                        step="1"
                                        value={stockNoNecesario ? '' : (hasConfiguredVariants ? totalStock : stockGeneral)}
                                        onChange={(e) => setStockGeneral(e.target.value)}
                                        readOnly={hasConfiguredVariants}
                                        disabled={stockNoNecesario}
                                    />
                                </fieldset>
                                <fieldset className='checkboxField'>
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={stockNoNecesario}
                                            onChange={(e) => setStockNoNecesario(e.target.checked)}
                                        />
                                        Stock no necesario
                                    </label>
                                </fieldset>
                                <fieldset>
                                    <legend>Precio anterior</legend>
                                    <input
                                        type="number"
                                        value={nuevoPrecioAnterior !== '' ? nuevoPrecioAnterior : producto.precioAnterior}
                                        onChange={(e) => setNuevoPrecioAnterior(e.target.value)}
                                    />
                                </fieldset>
                                <div className='items'>
                                    {itemFields.map((field, index) => (
                                        <fieldset key={field.legend}>
                                            <legend>{field.legend}</legend>
                                            <div className='itemInputGroup'>
                                                <span className='itemFieldLabel'>Talla</span>
                                                <input
                                                    type="text"
                                                    id={`item${index + 1}`}
                                                    name={`item${index + 1}`}
                                                    value={field.value}
                                                    onChange={(e) => field.setValue(e.target.value)}
                                                    placeholder='Ej: S'
                                                />
                                            </div>
                                            <div className='itemInputGroup'>
                                                <span className='itemFieldLabel'>Stock</span>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    step="1"
                                                    value={itemStocks[field.stockKey]}
                                                    onChange={(e) => handleItemStockChange(field.stockKey, e.target.value)}
                                                    placeholder="0"
                                                    disabled={stockNoNecesario}
                                                />
                                            </div>
                                        </fieldset>
                                    ))}
                                </div>
                            </div>




                            <button className='btnPost' onClick={() => handleUpdateText(producto.idProducto)} >Guardar </button>

                        </div>

                        <div className='sectionImg' style={{ display: selectedSection === 'imagenes' ? 'flex' : 'none' }}>
                            <p className='imageSectionHint'>Hasta 10 archivos: imagen 1200 x 1200 px o video MP4/WebM/OGG. Máximo 2 videos.</p>
                            <div className='previevProduct'>
                                {productMediaSlots.map((slot) => (
                                    <div className='previewProductCard' key={slot.key}>
                                        {slot.preview ? (
                                            <ProductMedia src={slot.preview} mediaType={slot.file?.type} alt={`Vista previa ${slot.label}`} className="productMediaThumb" onClick={() => abrirModalImagenSeleccionada(slot.preview)} controls={slot.file?.type?.startsWith('video/')} />
                                        ) : (
                                            <>
                                                {!removedImages[slot.key] && producto[slot.key] ? (
                                                    <ProductMedia src={producto[slot.key]} alt={slot.label} className="productMediaThumb" onClick={() => abrirModalImagenSeleccionada(producto[slot.key])} />
                                                ) : (
                                                    <span className='imgNone'>
                                                        No hay archivo
                                                    </span>
                                                )}
                                            </>
                                        )}
                                        <div className='previewProductActions'>
                                            {producto[slot.key] && !removedImages[slot.key] && !slot.preview && (
                                                <button type="button" className='linkDangerButton' onClick={() => markImageForRemoval(slot.key)}>
                                                    Eliminar
                                                </button>
                                            )}
                                            {slot.preview && (
                                                <button type="button" className='linkSecondaryButton' onClick={() => {
                                                    slot.setPreview(null);
                                                    slot.setFile(null);
                                                }}>
                                                    Quitar selección
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {productMediaSlots.map((slot) => (
                                <fieldset key={`input-${slot.key}`}>
                                    <legend>Editar {slot.label}</legend>
                                    <small className='fieldHint'>Imagen 1200 x 1200 px o video MP4/WebM/OGG. Máximo 2 videos.</small>
                                    <input type="file" accept={PRODUCT_MEDIA_ACCEPT} onChange={(e) => handleFileChange(e, slot.setFile, slot.setPreview, slot.key)} />
                                </fieldset>
                            ))}


                            <button className='btnPost' onClick={() => handleEditarImagenBanner(producto.idProducto)}>Guardar </button>

                        </div>



                    </div>
                </div>
            )}
            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th className='productColumnId'>Id Producto</th>
                            {shouldShowSkuColumn && <th className='productColumnTitle'>SKU</th>}
                            {shouldShowBrandColumn && <th className='productColumnBrand'>Marca</th>}
                            <th className='productColumnTitle'>Titulo</th>
                            <th className='productColumnCategory'>Categoria</th>
                            <th className='productColumnPrice'>Stock total</th>
                            <th className='productColumnVariants'>Stock variantes</th>
                            <th className='productColumnPrice'>Precio</th>
                            <th className='productColumnImage'>Imagen</th>
                            <th className='productColumnActions'>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {productosFiltrados.map(item => (
                            <tr key={item.idProducto}>
                                <td className='productColumnId'>{item.idProducto}</td>
                                {shouldShowSkuColumn && <td className='productColumnTitle'>{item.sku || '-'}</td>}
                                {shouldShowBrandColumn && <td className='productColumnBrand'>{item.marca || '-'}</td>}
                                <td className='productColumnTitle'>{item.titulo}</td>

                                {categorias
                                    .filter(categoriaFiltrada => categoriaFiltrada.idCategoria === item.idCategoria)
                                    .map(categoriaFiltrada => (
                                        <td
                                            key={categoriaFiltrada.idCategoria}
                                            className='productColumnCategory'
                                            style={{ color: '#DAA520' }}
                                        >
                                            {categoriaFiltrada.categoria}
                                        </td>
                                    ))
                                }
                                <td className='productColumnPrice'>
                                    {isStockNotRequired(item) ? (
                                        <span className='variantStockBadge is-unmanaged'><small>No necesario</small></span>
                                    ) : (
                                        <span className={`variantStockBadge ${getVariantStockToneClass(item?.stock)}`}>
                                            <small>{Number(item?.stock || 0)}</small>
                                        </span>
                                    )}
                                </td>
                                <td className='productColumnVariants'>
                                    <div className='variantStockPreview'>
                                        {isStockNotRequired(item) ? (
                                            <span className='variantStockEmpty'>No necesario</span>
                                        ) : getVariantStockPreview(item).length > 0 ? (
                                            getVariantStockPreview(item).map((variant) => (
                                                <span key={`${item.idProducto}-${variant.label}`} className={`variantStockBadge ${getVariantStockToneClass(variant.stock)}`}>
                                                    <strong>{variant.label}</strong>
                                                    <small>{variant.stock}</small>
                                                </span>
                                            ))
                                        ) : (
                                            <span className='variantStockEmpty'>Sin variantes</span>
                                        )}
                                    </div>
                                </td>
                                <td className='productColumnPrice' style={{
                                    color: '#008000',
                                }}>
                                    {isCustomPrice(item)
                                        ? 'Personalizable'
                                        : `${getProductMoneda(item)} ${`${item?.precio}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`}
                                </td>

                                <td className='productColumnImage'>
                                    {getFirstProductMedia(item) ? (
                                        <ProductMedia src={getFirstProductMedia(item)} alt="archivo1" className="productMediaThumb" />
                                    ) : (
                                        <span className='imgNonetd'>
                                            Sin imagen
                                        </span>
                                    )}
                                </td>

                                <td className='productColumnActions'>

                                    <button className='eliminar' onClick={() => eliminarProducto(item.idProducto)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                    <button className='editar' onClick={() => abrirModal(item)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                    <Anchor className='editar' to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`}>
                                        <FontAwesomeIcon icon={faEye} />
                                    </Anchor>
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>
        </div>
    );
};
